<template>
  <div v-if="date" class="country-notice">
    <!-- copyright과 스타일 맞춤 -->
    <span>@ 2020 H·ROBOTICS All Rights Reserved.</span>
    <span v-if="country">{{ country }}</span>
  </div>
</template>

<script>
export default {
  name: 'CountryNotice',
  data() {
    return {
      country: '',
      date: true // 렌더링 제어용
    };
  },
  mounted() {
    this.initCountry();
  },
  methods: {
    initCountry() {
      const countryCode = this.getCookie('user_country');

      if (countryCode) {
        this.setCountryFromCode(countryCode);
      } else {
        fetch('https://ipwho.is/')
            .then(response => response.json())
            .then(data => {
              if (data.country_code) {
                this.setCountryFromCode(data.country_code);

                let domainAttr = "";
                // Share cookie with subdomains if on production domain
                if (window.location.hostname.includes('rebless.clinic')) {
                  domainAttr = "; Domain=.rebless.clinic";
                }
                const maxAge = 86400; // 1 day
                document.cookie = `user_country=${data.country_code}; Path=/; Secure; SameSite=Lax; Max-Age=${maxAge}${domainAttr}`;
              }
            })
            .catch(error => console.error('Error fetching country:', error));
      }
    },
    setCountryFromCode(code) {
      try {
        const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
        this.country = regionNames.of(code);
      } catch (e) {
        this.country = code;
      }
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }
  }
}
</script>

<style scoped>
.country-notice {
  display: flex;
  justify-content: space-between;
  padding: 10px 30px;
  font-size: 12px;
  color: #999;
  background-color: #f5f5f5; /* PlatformView 배경색과 맞출 필요 있음 */
}
</style>
